import { Component } from "@angular/core";

import { TranslateModule } from "@ngx-translate/core";
import { MatDialogRef, MatDialogState } from "@angular/material/dialog";

@Component({
  selector: "app-offline",
  imports: [TranslateModule],
  templateUrl: "./offline.component.html",
  styleUrl: "./offline.component.scss",
})
export class OfflineComponent {
  isLoading = false;

  /**
   * Verifies connectivity against the server. PwaService replaces this with its real probe when
   * it opens the dialog; the fallback only re-reads the browser hint.
   */
  probe: () => Promise<boolean> = () => Promise.resolve(navigator.onLine);

  constructor(private dialogRef: MatDialogRef<OfflineComponent>) {}

  async retry(): Promise<void> {
    this.isLoading = true;
    // Keep the spinner visible for a moment so a fast failure still reads as "checked".
    const [reachable] = await Promise.all([
      this.probe(),
      new Promise<void>((resolve) => setTimeout(resolve, 1000)),
    ]);
    this.isLoading = false;
    if (reachable && this.dialogRef.getState() === MatDialogState.OPEN) {
      this.dialogRef.close();
    }
  }
}
